/*global $:false*/

import Idp from "./cob.authm.idp.js";

class AuthM {
    static loadAllIdps() {
        return new Promise(function(resolve) {
            $.ajax({
                url: "/authm/idps",
                type: 'GET',
                contentType: "application/json",
                success: function(data) {
                    return resolve(data.map((idp) => new Idp(idp.name, idp.uri)))
                },
                error: function(jqXHR) {
                    if (jqXHR.status !== 404) {
                        console.error("Error collecting idps from server");
                    }
                    return resolve([])
                }
            });
        })
    }
}

export default AuthM;